import React, { Component } from 'react';
// import Cookies from 'js-cookie';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import  Home  from './views/Home'
import Adaptability from './views/Adaptabilty';
import Data from './views/Data'
import Expertise from './views/Expertise';
import Cost from './views/Cost'
import Results from './views/Results';
import EmersonHeader from './components/EmersonHeader'
import EmersonFooter from './components/EmersonFooter';
// import CookieNotification from './components/CookieNotification';
import { ThemeProvider, createTheme, makeStyles } from '@mui/material/styles';
import { RoxarHeader } from './components/RoxarHeader';
import SideNav from './components/SideNav';

const theme = createTheme();

class App extends Component {
  // componentDidMount() {
  //   var gdpr_cookies = Cookies.get();
  //   console.log("All Cookies: " + JSON.stringify(gdpr_cookies));

  //   var gdpr_cookie_policy = Cookies.get('gdprcookiepolicy');
  //   console.log("Cookies: " + gdpr_cookie_policy);

  //   if (gdpr_cookie_policy) {
  //     //If a cookie exists we don't show the Cookie Policy
  //     this.setState({ ck: false });
  //   } else {
  //     //If a cookie does not exists we show the Cookie Policy
  //     this.setState({ ck: true });
  //   }
  // }

  // state = {
  //   ck: null
  // }

  // setCookie = (cname, cvalue, exdays) => {
  //   var d = new Date();
  //   d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  //   var expires = "expires=" + d.toGMTString();
  //   Cookies.set(`${cname}, ${cvalue}, {expires: ${expires}, path: "/;secure;SameSite=Strict"`);
  // }

//   closeCookies = (c) => {
//     this.setState({ ck: c });
//     this.setCookie("gdprcookiepolicy", "gdpr_cookie_policy;path=/;secure;SameSite=Strict", 30);
//   }

  render() {
    return (
      <ThemeProvider theme={theme}>

      <>
        <EmersonHeader />
        <React.Fragment>
          <Router basename='/flow/roxar-multiphase-roi-calculator/en'>
            <div className='app'>
              <RoxarHeader />
              <Switch>
                <Route path="/adaptability">
                  <Adaptability  />
                </Route>
                <Route path="/data">
                  <Data />
                </Route>
                <Route path="/expertise">
                  <Expertise />
                </Route>
                <Route path="/cost">
                  <Cost />
                </Route>
                <Route path= "/results">
                  <Results />
                </Route>
                <Route path="/">
                  <Home />
                </Route>
              </Switch>
              {/* <SideNav /> */}
            </div>
          </Router>
        </React.Fragment>
        <EmersonFooter />
        {/* { this.state.ck && <CookieNotification closeCookies={this.closeCookies} /> } */}
      </>
      </ThemeProvider>
    );  
  }
}

export default App;
